window.M = window.M || {};
window.M.Api = window.M.Api || {};

window.M.Api.makeCall = function(method, url, body, onComplete) {
	$.ajax({
		url: url,
		type: method,
		contentType: "application/json",
		data: body,
		error: function(xhr, textStatus, errorThrown) {
			onComplete(errorThrown, null, xhr);
		},
		success: function(data, textStatus, xhr) {
			onComplete(null, data, xhr);
		}
	});
};

window.M.Api.get = function(url, onComplete) {
	return M.Api.makeCall("GET", url, null, onComplete);
};
window.M.Api.post = function(url, body, onComplete) {
	return M.Api.makeCall("POST", url, body, onComplete);
};